export const GET_APPOINTMENTS = `
    query getAppointment($params: AppointmentParams!){
        appointments(params: $params) {
            GST
            amountPaid
            calendar
            canceled
            date
            email
            firstName
            lastName
            id
            paid
            phone
            price
            time
            type
            paymentSource
            totalBilled
            clientRate
            acuityID
            client {
                claimNumber
            }
        }
    }
`

export const GET_CLIENTS = `
    query getClients($search: String!) {
        clients(search: $search) {
            email
            firstName
            lastName
            notes
            phone
        }
    }
`

export const GET_INVOICE_NUMBER =`
    query {
        invoiceNumber
    }
`

export const GET_TOTAL_BILLED = `
    query getClients($params: AppointmentParams!) {
        appointments(params: $params) {
            totalBilled
        }
    }
`
export const GET_CALENDARS_LIST = `
    query getCalendars($params: DateParams!) {
        counsellors(params: $params) {
            acuityID
            fee
            share
            external
            name
            GSTEnabled
            email
            appointments {
                GST
                sessionLocation
                calendar
                date
                email
                firstName
                lastName
                id
                paid
                phone
                price
                time
                type
                paymentSource
                clientRate
                counsellorRate
                amountPaid
                client {
                    claimNumber
                    approvedSessions
                    dateOfApprovalCheck
                    expiryDate
                }
            }
        }
    }
`

export const GET_INVOICES_NUMBERS = `
    query getInvoicesNumbers($operationId: Int!) {
        extractedInvoiceNumbers(operationId: $operationId) {
            invoiceNumber
            invoiceId
            totalBilled
        }
    }
`

export const GET_ADMIN_COUNSELLORS = `
    query getAdminCounsellors ($params: DateParams!) {
        counsellors(params: $params) {
            name
            clients {
                id
                firstName
                isActive
                lastName
                paymentSource
                phone
                totalBilled
                usedSessions
                expiryDate
                chargedSessions
                approvedSessions
                mutationRequest
                dateOfApprovalCheck
                appointments {
                    amountPaid
                    price
                    paid
                }
                counsellor {
                    acuityID
                }
            }
        }
    }
`

export const GET_EMAIL_TEXT = `
    query getInvoicesNumbers {
        emailText {
            text
        }
    }
`

export const GET_BAD_FIT = `
query MyQuery {
        badFit {
            id
            isGrey
            isGoodFeet
            notes
            dateCreated
            client {
                lastName
                firstName
            }
            counsellor {
                name
            }
        }
    }

`
